<template>
  <div class="container_wrap">
    <div class="content_title">
        <template v-if="catedetailDataArr.extra_data&&catedetailDataArr.extra_data.length>0">
            <p>{{catedetailDataArr.extra_data[1].field_key=='career'?catedetailDataArr.extra_data[1].value+' :':''}}</p>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <p>{{catedetailDataArr.extra_data[0].field_key=='name'?catedetailDataArr.extra_data[0].value:'Nothing'}}</p>
        </template>
        <template v-else>
            {{ catedetailDataArr.title }}
        </template>
    </div>
    <div class="content_date">
      发布日期：{{ catedetailDataArr.create_time | timeFormat }}
    </div>
    <div class="content_container html-data" v-html="catedetailDataArr.content"></div>
  </div>
</template>
<script>
//特聘战略专家-爱心大导师   的详情
export default {
  name: "ContentSinglePage",
  data() {
    return {
      catedetailDataArr: [],
    };
  },
  mounted() {
      if(this.$route.name=="ContentSinglePage"){
        this.getCateDetailFun(this.$route.query.id);
      }else{
          this.$message.error("跳转错误");
      }
  },
  methods: {
    getCateDetailFun(id) {
      var that = this;
      that.$api.get(
        "/api/cms/detail",
        {
          id: id,
        },
        (res) => {
            console.log(res)
        //   if (res.data[0].tpl != "CateSinglePage") {
        //     return;
        //   }
          //   this.$message.success(res.data[0].name+"  获取成功");
          that.catedetailDataArr = res.data.data;
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        this.getCateDetailFun(this.$route.query.id);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: calc(100vh - 446px);
  overflow: hidden;
}
.content_title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 22px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: row;
  justify-content: center;
  p:nth-child(2){
      font-weight: normal;
  }
}
.content_date {
  width: 100%;
  text-align: center;
  font-size: 16px;
  margin-top: 5px;
  color: #9b9b9b;
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// ContentSinglePage.vue?fe97c5a4